export default "__VITE_ASSET__UrbqiqxU__"